<template>
  <div class="mobile historical-submission">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="historical_item" v-for="(item,index) in list" :key="index">
          <DsfHistoricalSubmissionCard :cardValue="item"></DsfHistoricalSubmissionCard>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import DsfHistoricalSubmissionCard from "./historicalSubmissionCard";
export default dsf.component({
  name: "DsfMobileHistoricalSubmission",
  ctrlCaption: "历史提交",
  mixins: [$mixins.control],
  components: {
    DsfHistoricalSubmissionCard
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: true,
      refreshing: false,

    };
  },
  created() {
    if (this.isDesign) {
      this.list = [{
        attachment:JSON.stringify([{relativePath: '/upload/files/20220304/5490bd5eefd34af3987ae42c8b5b59dc.jpg'}]),
        dsCreateTime: "2022-03-04 14:38",
        replyStatusValue:'0',
        replyStatusText: "未回复",
        suggest: "63456345345",
        typeText: "后勤保障",
        suggestReplyList:[]
      }]
    } else {
      this.getList();
    }
  },
  methods: {
    getList() {
      let data = {
        stuId: this.queryString.stuId || '',
        // stuId: 'e03c56cbff9641a3bea27e37b42845b0',
        searchValue: ''
      }
      let that = this;
      this.$http.get('/mobile/classes/suggest/getMySuggestList', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          that.list = res.data;
          that.finished = true;
          that.loading = false;
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })

    },
    onLoad() {

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = false;
      this.refreshing = false;
      this.list = [];
      this.getList();
    },
  },
})
</script>

<style>
</style>